import { mergeRegister } from '@lexical/utils';
import type { LexicalEditor } from 'lexical';
import { $isParagraphNode, COMMAND_PRIORITY_HIGH, KEY_ENTER_COMMAND, LineBreakNode, RootNode } from 'lexical';

/**
 * Keeps the content on one line.
 * - Enter is swallowed; line breaks (e.g. from a paste) are removed.
 * - Extra paragraphs are merged into the first, in the same update via a root transform.
 * - Returns the unregister function, like Lexical's own `register*` helpers.
 */
export const registerSingleLine = (editor: LexicalEditor): (() => void) =>
  mergeRegister(
    editor.registerCommand(
      KEY_ENTER_COMMAND,
      (event) => {
        event?.preventDefault();
        return true;
      },
      COMMAND_PRIORITY_HIGH,
    ),
    editor.registerNodeTransform(LineBreakNode, (node) => node.remove()),
    editor.registerNodeTransform(RootNode, (root) => {
      const [first, ...rest] = root.getChildren().filter($isParagraphNode);
      if (!first) return;
      for (const paragraph of rest) {
        first.append(...paragraph.getChildren());
        paragraph.remove();
      }
    }),
  );
